export default {"src":"/_next/static/media/img-mask.ae052c8d.svg","height":300,"width":300};